/// <summary>
/// This object provides js functions for the Bluaul.ManualEdit widget. <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 4.12.2020<br />
/// Copyright ©: EUDT GmbH 2020 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 4.12.2020                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.ManualEdit", $.common.VisualBase, {

    vcChart: null,
    bInit: false,
    bsaid: -1,
    valueList: null,
    dirty: false,
    saved: false,
    myChart: null,
    waitingCounter: 0, //increase while waiting for saved data
    waitingTimer: 2000, //waiting time
    maxWaitings: 20, //max waitings before stopping 
    chartType: 0, //raw data or archive
    dial: null, //helper for the waiting dialog
    bSelectCurrentTime: true,
    _create: function () {
        /**sets global values and inital values
         *
         */
        var me = this;

        try {
            /**
            * set the Visual-Name first
            * after that execute the parent function (_super())
            * to load the visual into the root-element
            */
            me.options.invoke.vcvid = 305;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me.bsaid = -1;

            //inits the super class
            me._super();


        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        var from, to;
        try {

            if (me.specific.singleStartBsaid > 0) {
                me.visual.find("#div-col1").hide().width(0);
            }

            //adopt heights and widths
            var h = parseInt(me.visual.height() -
                me.visual.find(".vc-date-box").height() -
                me.visual.find(".vc-list-header").height());
            me.visual.find(".lst-signals .vc-list-table").height(h - 36);
            me.valuesHeight = parseInt(me.visual.height());

            me.visual.find(".lst-values").height(parseInt((me.valuesHeight - me.visual.find(".div-add-value").height() - 135)));
            me.visual.find(".div-col, .chart").height(parseInt(me.visual.height()) - 30);
            me.visual.find("#div-col3").width(parseInt((me.visual.width() - me.visual.find("#div-col1").width() - me.visual.find("#div-col2").width() - 40)));

            me.visual.find('.lst-signals .vc-list-table .vc-list-item:even').addClass('alt');

            //decide when to start with the entry list
            var daysSubtract = 180;
            if (me.options.parameter.type > 2) { daysSubtract = 365 * 2 }
            if (me.specific.singleStartDate.length === 0) {
                from = moment(me.options.invoke.date, "DD.MM.YYYY HH:mm:ss").subtract(daysSubtract, 'days').format("DD.MM.YYYY");
                to = moment(me.options.invoke.date, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");
            } else {
                from = moment(me.specific.singleStartDate, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY");
                to = from;
            }
            me.element.find("#div-select-time .button-toggle").button();
            me.element.find("#div-select-time .button-toggle").off("click").on("click", function () { me._toggleTimeSelection(); });


            //init main date selection
            me.element.find(".vc-date-box").addClass("vc-grid-margin-right").vcDateBox({
                mode: "Range",
                align: "right",
                interval: 1,
                defaultRange: { from: from, to: to },
                langID: me.settings.userLangIDForCulture,
                callback: function () {
                    if (me.bInit) {

                        if (me.dirty) {
                            me.openAskDialog(me.specific.resources.saveChanges_lbl, { at: 'center center-30%', of: window }, function () { me._save(); return true; }, function () {
                                me._setDirty(false);
                            });

                        }
                        me._fetch();
                    }

                }
            });



            if (me.specific.singleStartBsaid > 0) {
                me.visual.find(".lst-signals .vc-list-table .vc-list-item").addClass("selected");
                me.visual.find("#div-col2, #div-col3").show();
                me._fetch(parseInt(me.visual.find(".lst-signals .vc-list-table .vc-list-item:first").data("id")));
            }

            //init input date
            me.visual.find('#div-add-date')
                .vcDate({ mode: 'Single', align: 'center', defaultDate: to, interval: 1, "time": true, langID: me.settings.userLangIDForCulture });

            //init the archive buttons for the chart type
            me.visual.find("#div-col3 .button-toggle").off("click").on("click",
                function () {
                    me.visual.find("#div-col3 .button-toggle").removeClass("button-toggle-active");
                    $(this).addClass("button-toggle-active");
                    me.chartType = parseInt($(this).data("type"));
                    me._showChartByType();
                }).button();

            //we have to adopt some stuff for the prices and co2
            if (me.options.parameter.type > 2) {
                me.visual.find("#ddl-month").val(moment().format("1.M.YYYY").toString());
                me.visual.find("#ddl-month").chosen({ search_contains: true, inherit_select_classes: true, width: "60%" });

            }

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            //init event listener
            _VCMQ.addConsumer(me.vcgid);
            _VCMQ.consume(me.visual, me.vcgid, function (event) { me._doEvent(event) });

            me.element.on("click", " #btn-add-point", function () { me._add() });
            me.visual.find("#btn-add-point").button();
            me.visual.find("#btn-add-point").button("option", "disabled", true);


            me.element.on("click", " #btn-save", function () { me._save() });
            me.visual.find("#btn-save").button();
            me.visual.find("#btn-save").button("option", "disabled", true);


            //input validation for input field
            me.visual.find('#txt-value').keyup(function () {

                var val = $(this).val().replace('.', '').trim();
                var bInvalid = false;
                if (val.length === 0) {
                    bInvalid = true;
                } else {
                    if ((validateNumeric(val) === false || isNaN(parseFloat(val)))) {
                        bInvalid = true;
                    }
                }
                if (bInvalid) {
                    me._toggleError(me.specific.resources.ERR_inputInvalid_lbl, true);
                } else {
                    me._toggleError("", false);
                }


            });


            //event for list edit and del
            me.element.on("keyup", ".lst-values", ".txtEnabled", function (e) { me._edit(e); });
            me.element.on("click", ".lst-values", ".icon-del", function (e) { me._del(e); });


            me.visual.find("#chb-edit").off("click").on("click", function () {
                me._toggleEditState();
            });


            //  list select handler
            me.element.on("click", ".lst-signals .vc-list-table .vc-list-item", function () {
                me.visual.find(".lst-signals .vc-list-table .vc-list-item").removeClass("selected");
                if (me.dirty) {
                    me.openAskDialog(me.specific.resources.saveChanges_lbl, { at: 'center center-30%', of: window }, function () { me._save(); return true; }, function () {
                        me._setDirty(false);
                    });

                }

                $(this).addClass("selected");
                me.visual.find("#div-col2, #div-col3").show();
                me.visual.find("#txt-value").val("");
                me.visual.find(".lst-values").html(me.getLoadingIcon());
                me._fetch(parseInt($(this).data("id")));

            });


            me.bInit = true;

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _doEvent: function (event) {
        /// <summary>
        /// Handles differet internal and external events
        /// </summary>
        var me = this;
        try {



            switch (event.msg) {
                case 'STILL_WAITING':

                    setTimeout(function () { me._waitForProcessed() }, me.waitingTimer);
                    break;
                case 'FINISHED_WAITING':
                    me.dial.dialog('close');

                    if (event.values) {
                        setTimeout(function () {
                            me.visual.find("#txt-value").val("");
                            me.visual.find(".lst-values").html(me.getLoadingIcon());

                            me._fetch(me.bsaid);
                        }, me.waitingTimer);
                    }
                    break;

                default: break;
            }
        } catch (ex) { me.writeError('doEvent', ex); }
    },


    _toggleTimeSelection: function () {
        /// <summary>
        /// This function switches between the the two different time selections
        /// </summary>
        var me = this;
        try {

            if (me.visual.find("#btn-current").hasClass("button-toggle-active")) {

                me.visual.find("#btn-current").removeClass("button-toggle-active");
                me.visual.find("#btn-history").addClass("button-toggle-active");
                me.visual.find("#div-current-info").hide();
                me.visual.find(".vc-date-box").show();

                me.bSelectCurrentTime = false;
            }
            else {

                me.visual.find("#btn-history").removeClass("button-toggle-active");
                me.visual.find("#btn-current").addClass("button-toggle-active");
                me.visual.find(".vc-date-box").hide();
                me.visual.find("#div-current-info").show();
                me.bSelectCurrentTime = true;
            }

        } catch (e) {
            me.writeError('_toggleTimeSelection', e);
        }


    },
    _add: function () {
        /// <summary>
        /// This function handles the adding of a new entry
        /// </summary>

        var me = this;
        try {
            //the list have to get reloaded after saving - before you can add new values
            if (me.saved) {
                me.openInfoDialog(me.specific.resources.firstReloadList_lbl, { at: 'center center-20%', of: window });
                return false;
            }

            //get the date from one of the two timers
            var date = me._getAddDate();
            var value = parseFloat(me.visual.find(".div-add-value #txt-value").val().replace(".", "").replace(",", "."));

            me._toggleError("", false);

            me.visual.find("#div-error").hide();
            if (value.length === 0 || isNaN(value)) {
                me._toggleError(me.specific.resources.ERR_inputInvalid_lbl, true);
                return false;
            }
            //everything stops if the entry already exists
            me._checkIfEntryExists(date, value);

            return true;

        } catch (e) {
            me.writeError('_add', e);
            return false;
        }
    },

    _getAddDate: function () {
        /// <summary>
        /// This function decides where to get the date for the new entry from (based on the start type)
        /// </summary>
        var me = this;
        var date;
        var dt;
        try {
            if (me.options.parameter.type > 2) {
                date = me.element.find("#div-col2 #ddl-month").val();
                dt = moment(date, "DD.MM.YYYY HH:mm");
            } else {
                date = me.element.find("#div-col2 .vc-date").vcDate("getDate");
                dt = moment(date.from + " " + date.time, "DD.MM.YYYY HH:mm");

            }
            return dt;
        } catch (e) {
            me.writeError('_getAddDate', e);
            return null;
        }
    },



    _sortIntoList: function (dt, value) {
        /// <summary>
        /// This function sorts a new entry into 
        /// </summary>
        var me = this;
        var lstTmp = [];
        var bFound = false;
        var bFoundAny = false;
        try {

            //find out if the date already exist ...
            //and sort the list into a new list
            for (var i = 0; i <= me.valueList.length - 1; i++) {
                //sorting
                if (moment(dt.diff(moment(me.valueList[i].dt), "seconds"))._i < 0) {
                    if (!bFound) {
                        lstTmp.push({ "dt": dt, "value": value, "type": 1 });
                    }
                    bFound = true;
                    bFoundAny = true;
                }
                lstTmp.push(me.valueList[i]);
            }

            //if it's the latest we have to add it here
            if (!bFoundAny) {
                lstTmp.push({ "dt": dt, "value": value, "type": 1 });
            }

            me.valueList = lstTmp;
            me._generateValueList();
            me._setDirty(true);

            me.visual.find(".div-add-value #txt-value").val("");

            return true;
        } catch (e) {
            me.writeError('_sortIntoList', e);
            return false;
        }
    },


    _edit: function (e) {
        /// <summary>
        /// This function handles the editing/deleting of an existing entry
        /// </summary>
        var me = this;
        var item;
        var val;
        try {


            if ($(e.target).hasClass("txtEnabled") === false) {
                return false;
            }
            $(e.target).removeClass("error");
            item = $(e.target).parents(".vc-list-item");
            if (me.valueList !== null) {

                //validate the input

                val = parseFloat($(e.target).val().replaceAll(".", "").replaceAll(",", "."));
                if (isNaN(val)) {
                    $(e.target).removeClass("error").addClass("error");
                    me.visual.find("#my-chart").html($("<div>").addClass("error").html(me.specific.resources.ERR_inputInvalid_lbl));
                    me._setDirty(true);
                    return false;
                }

                //iterate the list, find the entry and decide if it was edited or deleted (or ignored)
                for (var i = 0; i <= me.valueList.length - 1; i++) {
                    if (me.valueList[i].index === parseInt($(e.target).data("index"))) {

                        if (val !== me.valueList[i].value) {
                            me.valueList[i].value = val;
                            me.valueList[i].y = me.valueList[i].value;

                            if (me.valueList[i].type !== 1 && me.valueList[i].type !== 4) {
                                item.find(".l .sub").addClass("edited");
                                item.find(".l .type").html(me.specific.resources.edited_lbl);
                                me.valueList[i].type = 2;
                            }
                            if (me.valueList[i].type === 4) {
                                item.find(".l .sub").addClass("edited");
                                item.find(".l .type").html(me.specific.resources.new_lbl);
                                me.valueList[i].type = 1;
                            }
                            //    }
                        }

                        me._setDirty(true);
                    }
                }

            }

            me._showChartByType();
            return true;
        } catch (e) {
            me.writeError('_edit', e);
            return false;
        }
    },


    _del: function (e) {
        /// <summary>
        /// This function handles the deleting of an existing entry
        /// </summary>
        var me = this;
        var item;
        var lstTmp = [];
        try {

            if ($(e.target).hasClass("icon-del") === false) {
                return false;
            }

            item = $(e.target).parents(".vc-list-item");
            item.find(".txtEnabled").removeClass("error");
            if (me.valueList !== null) {

                //iterate the list, find the entry and decide if it was edited or deleted (or ignored)
                for (var i = 0; i <= me.valueList.length - 1; i++) {
                    if (me.valueList[i].index === parseInt($(e.target).data("index"))) {
                        item.find(".txt").val("");
                        //if a new entry get's deleted - we ignore it
                        if (me.valueList[i].type === 1) {
                            me.valueList[i].type = 4;
                            item.hide();
                        } else {

                            item.find(".l .sub").addClass("edited");
                            item.find(".l .type").html(me.specific.resources.deleted_lbl);
                            me.valueList[i].type = 3;
                            lstTmp.push(me.valueList[i]);
                        }
                        me._setDirty(true);

                    } else {
                        lstTmp.push(me.valueList[i]);
                    }
                }

            }

            me.valueList = lstTmp;
            me.visual.find('.lst-values.vc-list-table .vc-list-item').removeClass('alt');
            me.visual.find('.lst-values.vc-list-table .vc-list-item:even').addClass('alt');


            me._showChartByType();
            return true;
        } catch (e) {
            me.writeError('_del', e);
            return false;
        }
    },


    _findOutliers: function () {
        /// <summary>
        /// This function marks entries in meter readings if the new reading is lower the previous one 
        /// </summary>
        var me = this;
        // var item;
        var val = -999999999;
        var bDecrease;
        try {

            if (me.options.parameter.type > 2) {
                return true;
            }
            if (me.valueList !== null) {

                //iterate the list, find the entry and decide if it was edited or deleted (or ignored)
                for (var i = 0; i <= me.valueList.length - 1; i++) {
                    bDecrease = false;
                    if (me.valueList[i].type < 3) {
                        bDecrease = val > me.valueList[i].value;
                        val = me.valueList[i].value;
                    } else {
                        val = "";
                    }
                    if (bDecrease) {
                        me.visual.find('.lst-values .vc-list-item[data-index="' +
                            me.valueList[i].index +
                            '"] .icon-decrease').show();
                    } else {
                        me.visual.find('.lst-values .vc-list-item[data-index="' + me.valueList[i].index + '"] .icon-decrease').hide();
                    }
                }
            }
            return true;
        } catch (e) {
            me.writeError('_findOutliers', e);
            return false;
        }
    },


    _toggleEditState: function () {
        /// <summary>
        /// This function switches between the edit state and the read only state
        /// </summary>
        var me = this;
        try {
            if (me.visual.find("#chb-edit").prop("checked")) {

                me.visual.find(".lst-values .vc-list-col.r .txtEnabled").prop("disabled", false).prop("readonly", false).removeClass("disabled");
                me.visual.find(".lst-values .vc-list-col.r .icon-del").show();
            } else {
                me.visual.find(".lst-values .vc-list-col.r .txtEnabled").prop("disabled", true).prop("readonly", true).removeClass("disabled").addClass("disabled");
                me.visual.find(".lst-values .vc-list-col.r .icon-del").hide();
            }

        } catch (e) {
            me.writeError('_toggleEditState', e);
        }
    },


    _toggleError: function (msg, bMarkInvalidInput) {
        /// <summary>
        /// show hide errors
        /// </summary>
        var me = this;
        try {
            if (msg.length > 0) {
                if (bMarkInvalidInput) { me.visual.find(".div-add-value #txt-value").removeClass("error").addClass("error"); }
                me.visual.find("#div-error").html(msg).show();
                me.visual.find("#btn-add-point").removeClass("vc-grid-margin-top");
            } else {
                me.visual.find(".div-add-value #txt-value").removeClass("error");
                me.visual.find(".div-add-value #div-error").hide();
                me.visual.find("#btn-add-point").removeClass("vc-grid-margin-top").addClass("vc-grid-margin-top");
            }

        } catch (e) {
            me.writeError('_toggleError', e);
        }
    },

    _fetch: function (bsaid) {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        var param;
        var dateRange;
        var oldBsaid;
        try {

            if (bsaid === -1) { return true; }
            //if we still wait for processing data - we stop here
            me.waitingCounter = 0;
            oldBsaid = me.bsaid;
            me.bsaid = bsaid;
            if (me.bsaid === -1) { return true; }

            me.visual.find("#btn-add-point").button("option", "disabled", true);

            dateRange = me.element.find("#div-col1 .vc-date").vcDate("getDate");


            me.visual.find("#chb-edit").prop("checked", false);

            //if we reload the same signal we extend the time interval if necessary 
            if (oldBsaid === me.bsaid) {

                if (me.valueList.length > 0) {
                    if (moment(moment(dateRange.from, "DD.MM.YYYY").diff(moment(me.valueList[0].dt, "DD.MM.YYYY"), "seconds"))._i > 0) {
                        //the list starts before the first date of the vcDate
                        dateRange.from = moment(me.valueList[0].dt, "DD.MM.YYYY").format("DD.MM.YYYY");
                    }

                    if (moment(moment(dateRange.to, "DD.MM.YYYY").diff(moment(me.valueList[me.valueList.length - 1].dt, "DD.MM.YYYY"), "seconds"))._i < 0) {
                        //the list ends after the last date of the vcDate
                        dateRange.to = moment(me.valueList[me.valueList.length - 1].dt, "DD.MM.YYYY").format("DD.MM.YYYY");
                    }
                }

            }


            //set param for ajax request
            param = {
                Type: 1,
                Bsaid: me.bsaid,
                StartDate: dateRange.from,
                EndDate: dateRange.to
            };

            if (me.bSelectCurrentTime) {
                param.StartDate = "";
                param.EndDate = "";
            }


           me.getData( param, function (result) {
                //check response content
                //me.valueList = null;
                if (result === null) {
                    me.valueList = [];
                } else {

                    me.valueList = result;
                }

                me._setDirty(false);
                me._generateValueList();
                me.visual.find("#btn-add-point").button("option", "disabled", false);
                return true;
            });

        } catch (e) {
            me.writeError('_fetch', e); return false;
        }
        return true;
    },


    _checkIfEntryExists: function (dt, value) {
        /// <summary>
        /// This function fetches existing entries and validates if the entry already exits.
        /// If not it adds it into the existing list. 
        /// </summary>
        var me = this;
        var param;
        try {


            if (me.bsaid === -1) { return true; }

            //find out if the date already exist ...
            //and sort the list into a new list
            for (var i = 0; i <= me.valueList.length - 1; i++) {
                if (me.valueList[i].type < 4) {

                    if (moment(dt.diff(moment(me.valueList[i].dt), "seconds"))._i === 0) {
                        me._toggleError(me.specific.resources.ERR_entryAlreadyExists_lbl, false);
                        return false;
                    }
                }

            }

            //set param for ajax request
            param = {
                Type: 2,
                Bsaid: me.bsaid,
                StartDate: moment(dt).format("DD.MM.YYYY HH:mm:ss")
            };

           me.getData( param, function (result) {

                //check response content
                if (result === null) {
                    me.showInfo(me.resources.err_code, me.resources.err_sub, true);
                    return false;
                } else {

                    if (result) {
                        me._toggleError(me.specific.resources.ERR_entryAlreadyExists_lbl, false);
                        return false;
                    }
                    me._sortIntoList(dt, value);
                }

                return true;
            });

        } catch (e) {
            me.writeError('_checkIfEntryExists', e); return false;
        }
        return true;
    },

    _generateValueList: function () {
        /// <summary>
        /// This function checks if everything is right
        /// </summary>
        var me = this;
        var item;
        var left;
        var info;
        var val = 99999999999;
        var right;
        try {


            me.visual.find(".lst-values").html("");


            if (me.valueList.length === 0) {

                me.visual.find(".lst-values").html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                me.visual.find(".chart").html("");
                return true;
            }

            for (var i = me.valueList.length - 1; i >= 0; i--) {

                me.valueList[i].index = i;
                item = $("<div>").addClass("vc-list-item").attr("data-index", i);
                if (me.valueList[i].type === 4) {
                    item.hide();
                }
                info = $("<div>").addClass("type");

                switch (me.valueList[i].type) {
                    case 1: //new
                        info.html(me.specific.resources.new_lbl); break;
                    case 2: //edited
                        info.html(me.specific.resources.edited_lbl); break;
                    case 3: //deleted
                        info.html(me.specific.resources.deleted_lbl); break;
                    default:
                }

                left = $("<div>").addClass("sub").html(info);
                left.append($("<div>").html(moment(me.valueList[i].dt).format("DD.MM.YYYY HH:mm") + " h"));
                if (me.valueList[i].type > 0) {
                    left.addClass("edited");
                }
                item.append($("<div>").addClass("vc-list-col l").append(left));

                if (me.valueList[i].type < 3) {

                    val = me.valueList[i].value;
                } else {
                    val = "";
                }

                right = $("<div>").addClass("vc-list-col r").html($("<input>").prop("disabled", true)
                    .prop("readonly", true).addClass("txt txtEnabled disabled").data("index", i).val(val)
                    .formatDouble(me.specific.digits ));
                right.append($("<i>").addClass('fa fa-times icon-color-error vc-list-icon icon-del').data("index", i));
                right.append($("<i>").addClass('fa fa-sort-amount-down icon-color-error vc-list-icon icon-decrease').attr("title", me.specific.resources.meterReadingDecreases_lbl));
                item.append(right);

                me.visual.find(".lst-values").append(item);

            }

            me._findOutliers();

            me._toggleEditState();

            me.visual.find('.lst-values.vc-list-table .vc-list-item:even').addClass('alt');


            me._showChartByType();

        } catch (e) {
            me.writeError('_generateValueList', e); return false;
        }
        return true;
    },


    _showChartByType: function () {
        /// <summary>
        /// This function shows one of the two charts
        /// </summary>
        var me = this;
        try {
            if (me.chartType === 0) {
                me._showHrChart();
            } else {
                me._showArchiveChart();
            }
        } catch (e) {
            me.writeError('_showChartByType', e);
        }

    },


    _showHrChart: function () {
        /// <summary>
        /// This function generates a simple chart based on the entry list
        /// It get's permanently updated
        /// </summary>
        var me = this;
        var data;
        try {

            if (me.bsaid === -1) { return true; }

            if (me.myChart !== null) {
                me.myChart.destroy();
            }

            var ro = new RampOptions();
            var chart = ro.getTheme();

            Highcharts.setOptions({ global: { useUTC: false } });
            chart.xAxis.labels.rotation = -90;
            chart.title = { text: (me.specific.resources.preview_lbl) }
            chart.chart.boost = { useGPUTranslations: true }
            chart.chart.animation = false;
            chart.chart.defaultSeriesType = "spline";
            chart.chart.marginLeft = 100;
            chart.chart.zoomType = "xy";
            chart.plotOptions = {
                series: { turboThreshold: 0 }
            };
            chart.xAxis.type = 'datetime';
            chart.xAxis.tickPixelInterval = 50;
            chart.xAxis.dateTimeLabelFormats = { day: '%d.%m.' };
            chart.xAxis.labels = { formatter: function () { return Highcharts.dateFormat('%d.%m.%Y', this.value); } }

            chart.yAxis.labels = { formatter: function () { return Highcharts.numberFormat(this.value, 3, ',', '.'); } }
            chart.yAxis.title = { text: "" }

            chart.legend = { enabled: false }
            chart.tooltip.formatter = function () { return '<u>' + moment(new Date(this.x)).format('DD.MM.YYYY HH:mm') + ' h</u>:<br/><b>' + Highcharts.numberFormat(this.y, me.digits, ',', '.') };
            chart.tooltip.positioner = function () { return { x: 0, y: 0 }; }

            var item;
            data = [];

            //generate the series and mark new/edited points with a special marker
            for (var i = 0; i <= me.valueList.length - 1; i++) {

                if (me.valueList[i].type < 3) {
                    item = me.valueList[i];

                    item.x = new Date(moment(item.dt, "DD.MM.YYYY HH:mm"));
                    item.y = item.value;
                    switch (item.type) {
                        case 1: //new
                            item.marker = { "radius": 6 };
                            break;

                        case 2: //edited
                            item.marker = { "radius": 6 };
                            break;
                    }

                    data.push(item);
                }
            }
            chart.series = [{ "name": "", "data": data, marker: { enabled: true, radius: 3 } }];

            me.myChart = Highcharts.chart("my-chart", chart);


            return true;
        } catch (e) {
            me.writeError('showChart', e); return false;
        }

    },


    _showArchiveChart: function () {
        /// <summary>
        /// This function generates a simple chart based on the entry list
        /// It get's permanently updated
        /// </summary>
        var me = this;
        var vcV = new vcVisual();
        var param;
        var signalParam = { 'series': [] };
        try {

            if (me.bsaid === -1) { return true; }

            if (me.valueList.length === 0) {
                return true
            }

            me.visual.find("#my-chart").html(me.getLoadingIcon());

            param = { 'loggerID': me.specific.blid, 'UsePrices': false, 'FixTooltip': true, 'HideLegend': true, 'NoZoom': false, 'ShowInvalidValues': false, 'ShowPlotLines': true, 'ShowIntervention': false, 'ShowEmptyChart': true, 'ShowExportIcons': false }
            var series = { 'bsaid': [me.bsaid], 'rule': '[bsaid=' + me.bsaid + ']', 'ruleType': 1 };
            signalParam.series.push(series);
            //main chart in the middle
            param.datatype = 2;


            var dateRange = me.element.find("#div-col1 .vc-date").vcDate("getDate");


            if (me.bSelectCurrentTime) {
                param.startDate = moment(me.valueList[0].dt).format("DD.MM.YYYY");
                param.endDate = moment(me.valueList[me.valueList.length -1].dt).format("DD.MM.YYYY");
            } else {
                param.startDate = dateRange.from;
                param.endDate = dateRange.to;
            }
                param.DateuserDef = true;
            signalParam.series[0].seriesType = "column";
           
            vcV.addVisualBaseByName('my-ch', "VISUAL_RAMP_DAILY", "art", param.startDate, parseInt(me.visual.find("#my-chart").height()), parseInt(me.visual.find("#my-chart").width()), JSON.stringify(param), JSON.stringify(signalParam), (me.options.invoke.deviceType), function () {
               
            });

            return true;
        } catch (e) {
            me.writeError('showArchiveChart', e); return false;
        }

    },

    _save: function () {
        /// <summary>
        /// This function sends the update request - quite simple
        /// </summary>
        var me = this;
        var data;
        var param;
        try {

            if (me.bsaid === -1) { return true; }

            data = [];
            //we only need entries which have been manipulated
            for (var i = 0; i <= me.valueList.length - 1; i++) {
                if (me.valueList[i].type > 0) {
                    data.push(me.valueList[i]);
                }
            }

            if (data.length === 0) {
                me._setDirty(false);
                me.saved = true;
                return true;
            }
            param = {"bsaid": me.bsaid, "data": data}

            me.updateData(param, function (result) {

                if (result === true) {
                    me.waitingCounter = 0;
                    setTimeout(function () { me._waitForProcessed() }, me.waitingTimer);

                    //me.visual.find(".lst-values").html($("<div>").addClass("note").html(me.getLoadingIcon() + " " + me.specific.resources.dataIsProcessed_lbl + "<br/><br/>" + me.specific.resources.bePatient_lbl + "<br/>"));

                    me.dial = $("<p><br/><img src='../../images/visualcore/loading.gif' style='height:15px'   /> " +  me.specific.resources.dataIsProcessed_lbl + "<br/><br/>" + me.specific.resources.bePatient_lbl + "<br/></p>").dialog({
                        position: { at: 'center center-20%',  of: window },
                        title: me.specific.resources.validation_lbl, modal: true,
                        dialogClass: 'saveDialog'
                    });
                
                    me._setDirty(false);




                } else {
                    me.visual.find(".lst-values").html($("<div>").addClass("error").html(me.resources.err_saveData));
                }
                me.saved = true;
                me.visual.find("#btn-add-point").button("option", "disabled", true);
                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },

    _setDirty: function (bDirty) {
        var me = this;
        try {

            if (me.bsaid === -1) { return true; }
            me.dirty = bDirty;
            if (!bDirty) { me.saved = false; }

            if (me.visual.find(".lst-values .txtEnabled.error").length > 0) {
                me.visual.find(" #btn-save").button("option", "disabled", true);
                return true;
            }

            me.visual.find(" #btn-save").button("option", "disabled", !me.dirty);

            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    },

    _waitForProcessed: function () {
        /// <summary>
        /// This function sends an request until the result is true - so, all data has been processed
        /// </summary>
        var me = this;
        var param;
        try {

         
            if (me.bsaid === -1) { return true; }

            if (me.waitingCounter < me.maxWaitings) {
                me.waitingCounter += 1;
            } else {
                _VCMQ.produce(me.visual, me.vcgid, 'FINISHED_WAITING', false);
                me.waitingCounter = 0;
                return true;
            }


            param = { "bsaid": me.bsaid, "type": 3 }

            me.getData(param, function (result) {
           
                if (result === true) {
                    _VCMQ.produce(me.visual, me.vcgid, 'FINISHED_WAITING', true);
                } else {
                    if (result !== null) {
                        _VCMQ.produce(me.visual, me.vcgid, 'STILL_WAITING', "");
                    } else {
                        _VCMQ.produce(me.visual, me.vcgid, 'FINISHED_WAITING', false);
                    }
                }

            
                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_waitForProcessed', e); return false;
        }

    },

    specificInfoHandling: function(bError) {
        var me = this;
        try {
            if (bError) {
                me.visual.find("#div-col1, #div-col2, #div-col3").hide();
            }
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }


});
